/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const OPERATIONS_SERVICE = {
    list,
    listSummary,
    listCosts,
    getComparativeData,
    remove,
    get,
    add,
    exportExcel
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Operations";

/* Services */
function list(resultsNumber, pageNumber, startDate, endDate, task, place, person, tool, orderBy)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetOperationsList"]);    

    var queryParams = { "resultsNumber":resultsNumber, "pageNumber": pageNumber, "startDate": startDate, "endDate": endDate, "task":task, "place":place, "employee":person, "tool": tool, "orderBy": orderBy };

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function listSummary()
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetOperationsSummary"]);    

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function listCosts(startTime, endTime, task, place, person, tool)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetOperationsCost"]);    

    var queryParams = { "startTime": startTime, "endTime": endTime, "task":task, "place":place, "employee":person,  "tool":tool };
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function getComparativeData(startTime, endTime, orderBy, orderByType)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetComparativeData"]);    

    var queryParams = { "startTime": startTime, "endTime": endTime, "orderBy":orderBy, "orderByType":orderByType };
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function add(operation) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RegisterOperation"]); 

    let formData = new FormData();
    formData.append("data", JSON.stringify(operation));

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function get(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetOperation", id]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function remove(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, 'RemoveOperation', id]);    
    const requestOptions = {
        method: 'DELETE' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function exportExcel(startDate, endDate, task, place, person, tool)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "ExportExcel"]);    

    var queryParams = { "startDate":startDate, "endDate":endDate, "task":task, "place":place, "person":person, "tool":tool};


    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }, 
        responseType: "arraybuffer"
    };

    // Build query parameters
    var fullUrl = encodeURI(url);

    if(queryParams)
    {
        fullUrl += "?";
        for(var key in queryParams) 
        {
            var value = queryParams[key];
            
            if(value || value === 0)
            {
                var encodedValue = encodeURIComponent(value);
                
                fullUrl += `${key}=${encodedValue}&`;
            }
        }
        
        // Remove last character (? or &)
        fullUrl = fullUrl.substring(0, fullUrl.length - 1);
        console.log(fullUrl)
    }

    return fetch(fullUrl, requestOptions)
    .then(response =>{

        if (!response.ok) {
            var errorMsg;

            switch(response.status)
            {
                case 401:
                    {
                        errorMsg = "The token is not valid.";

                        store.dispatch('account/logout', null, { root: true });
                        break;
                    }
                default:
                    {
                        errorMsg = "Something went wrong, please try again. If the problem persists contact the support.";
                        break;
                    }
            }

            return Promise.reject(errorMsg);
        }
        
        return response.blob();   
    })
    .then(blob => 
    {
        saveAs(blob, 'operacoes.xlsx');
        return true;
    });
}
